import { Flex, Spinner, Text } from "@instructure/ui";
import { t } from "i18next";

const CustomLoader = () => {
  return (
    <Flex height="30rem" justifyItems="center">
      <Flex.Item textAlign="center">
        <Spinner renderTitle={"Loading Evidence"} size="large" />
        <Text weight="bold" size="large" as="div">
          {t("documentViewer.loadingEvidence")}...
        </Text>
      </Flex.Item>
    </Flex>
  );
};

export default CustomLoader;
